import { render, staticRenderFns } from "./H5Footer.vue?vue&type=template&id=421e3f6f&scoped=true&"
import script from "./H5Footer.vue?vue&type=script&lang=js&"
export * from "./H5Footer.vue?vue&type=script&lang=js&"
import style0 from "./H5Footer.vue?vue&type=style&index=0&id=421e3f6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421e3f6f",
  null
  
)

export default component.exports